<template>
    <link-popover
        ref="popover"
        v-bind="popoverBinding"
        @show="pl_open"
        @close="pl_close">
        <div class="link-select-service">
            <link-render-func v-if="option.content" :renderFunc="option.content"/>
            <template v-else>
                <div
                    class="link-select-service-item"
                    v-for="(item,index) in option.data"
                    ref="items"
                    :key="index"
                    :class="{'link-select-service-item-inner-hover':index === hoverIndex}"
                    @click="pl_click(item)">
                    <link-render-func v-if="!!option.render" :render-func="option.render" :data="{item,index}" class="link-select-service-item-inner"/>
                    <link-scope-slot v-else-if="!!option.slot" :scope-slot-func="option.slot" :data="{item,index}" class="link-select-service-item-inner"/>
                    <div class="link-select-service-item-inner" v-else>
                        <div class="link-select-service-item-inner-content">
                            <link-icon :icon="item[option.iconKey]" v-if="!!option.iconKey"/>
                            <span>{{!!option.labelKey?item[option.labelKey]:item}}</span>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </link-popover>
</template>

<script>
    export default {
        name: "link-select-service",
        data() {
            return {
                defaultOption: {
                    reference: null,
                    data: [],
                    popper: null,
                    popover: null,
                    labelKey: null,
                    valueKey: null,
                    autoFocus: true,
                    render: null,
                    slot: null,
                    autoClose: true,
                    onConfirm: null,
                    onClose: null,
                    iconKey: null,
                },

                popover: null,
                p_show: null,
                hoverIndex: null,
                watchData: null,
                rs: null,
                p_option: null,
            }
        },
        computed: {
            popoverBinding() {
                return {
                    reference: this.option.reference,
                    popover: this.option.popover,
                    popper: {
                        ...(this.option.popper || {}),
                        cls: 'pl-select-service-popper',
                    }
                }
            },
            option() {
                return Object.assign({}, this.defaultOption, this.p_option)
            },
        },
        watch: {
            watchData: {
                deep: true,
                async handler(val) {
                    if (!!this.p_show) {
                        await this.$lv.nextTick()
                        this.popover.$refs.popper.p_popper.update()
                    }
                },
            },
        },
        mounted() {
            this.popover = this.$refs.popover
        },
        methods: {
            async select(option) {
                this.hoverIndex = null
                this.p_option = option
                this.watchData = option.watchData
                await this.$lv.nextTick()
                this.popover.show()
                return this
            },
            hide() {
                this.popover.hide()
            },
            confirm() {
                this.pl_click(this.option.data[this.hoverIndex])
            },
            next() {
                if (this.hoverIndex == null) {
                    this.hoverIndex = 0
                    return
                }
                if (this.hoverIndex < (this.option.data.length - 1)) {
                    this.hoverIndex++
                    const item = this.$refs.items[this.hoverIndex]
                    const wrapper = this.popover.$refs.scroll.$refs.wrapper
                    const scrollTop = item.offsetTop + item.offsetHeight - wrapper.offsetHeight
                    if (scrollTop > 0 && scrollTop > wrapper.scrollTop) {
                        this.popover.$refs.scroll.scrollTop(scrollTop, 25)
                    }
                } else {
                    this.hoverIndex = 0
                    this.popover.$refs.scroll.scrollTop(0, 25)
                }
            },
            prev() {
                if (this.hoverIndex == null) {
                    this.hoverIndex = 0
                    return
                }
                if (this.hoverIndex > 0) {
                    this.hoverIndex--
                    const item = this.$refs.items[this.hoverIndex]
                    const wrapper = this.popover.$refs.scroll.$refs.wrapper
                    if (wrapper.scrollTop > item.offsetTop) {
                        this.popover.$refs.scroll.scrollTop(item.offsetTop, 25)
                    }
                } else {
                    this.hoverIndex = this.option.data.length - 1
                    this.popover.$refs.scroll.scrollTop(this.$refs.items[this.$refs.items.length - 1].offsetTop, 25)
                }
            },
            pl_click(item) {
                if (!item) return
                !!this.rs && this.rs(item)
                !!this.option.autoClose && this.popover.hide()
                !!this.option.onConfirm && this.option.onConfirm(item)
            },
            pl_open() {
                this.p_show = true
                !!this.option.onOpen && this.option.onOpen()
            },
            pl_close() {
                this.p_show = false
                !!this.option.onClose && this.option.onClose()
            },
        },
    }
</script>

<style lang="scss">
    @include themeify {
        .link-select-service {
            width: 100%;
            box-sizing: border-box;
            padding: 3px;

            .link-select-service-item {
                min-height: 24px;
                margin-bottom: 3px;
                padding: 4px 9px;
                font-size: 12px;
                cursor: pointer;
                box-sizing: border-box;
                width: 100%;

                &.link-select-service-item-inner-hover, &:hover {
                    background-color: pl-var(color-primary-light);
                }
            }
        }
    }
</style>
